import { ClientCreation } from '@Arti-zen/package-backoffice'
import { Button } from '@mui/material'
import styled from 'styled-components'
import { Theme } from 'theme/theme'
import ClientListTable from '../ClientListTable'

type TProps = {
  csv: string
  clients: ClientCreation[]
  onModify: boolean
}

export default function ClientsAfterUploading({ csv, clients, onModify }: TProps) {
  const downloadCSV = async () => {
    const blob = new Blob(['\uFEFF' + csv], {
      type: 'text/csv;charset=utf-8',
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = onModify ? 'clients-modifies' : 'clients-importes.csv'
    link.click()
    URL.revokeObjectURL(url)
  }

  return (
    <>
      {csv && (
        <Button
          onClick={downloadCSV}
          style={{
            backgroundColor: Theme.colors.greenArtizen,
            color: 'white',
          }}
        >
          Télécharger le fichier CSV des clients {onModify ? 'modifiés' : 'importés'}
        </Button>
      )}
      <Title>
        Clients {onModify ? 'modifiés' : 'importés'} : {clients?.length ?? '0'}
      </Title>
      <ClientListTable
        data={clients}
        correctClient={() => {}}
        openForm={() => {}}
        onModify={onModify}
        replaceAllErrors={() => {}}
      />
    </>
  )
}

export const Title = styled.p`
  font-family: ${Theme.font.family};
  font-size: 15px;
  font-weight: 600;
  color: ${Theme.colors.blackArtizen};
`
